import { Compass, Target } from "lucide-react";
import { useLang } from "../contexts/LanguageContext";

export default function About() {
  const { t } = useLang();

  return (
    <section
      id="about"
      className="relative py-24 sm:py-32 border-t border-white/5"
      data-testid="about-section"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-10 grid lg:grid-cols-12 gap-12 lg:gap-16">
        <div className="lg:col-span-5">
          <SectionTag>{t.about.tag}</SectionTag>
          <h2
            className="font-display mt-5 text-3xl sm:text-4xl lg:text-5xl text-white font-bold tracking-tight leading-[1.1]"
            data-testid="about-title"
          >
            {t.about.title}
          </h2>
        </div>

        <div className="lg:col-span-7 space-y-10">
          <p className="text-slate-200 text-base sm:text-lg leading-[1.8]">
            {t.about.intro}
          </p>

          <div className="grid sm:grid-cols-2 gap-6">
            <Pillar
              icon={<Compass size={20} />}
              title={t.about.vision_title}
              body={t.about.vision}
              testId="about-vision"
            />
            <Pillar
              icon={<Target size={20} />}
              title={t.about.mission_title}
              body={t.about.mission}
              testId="about-mission"
            />
          </div>
        </div>
      </div>
    </section>
  );
}

function Pillar({ icon, title, body, testId }) {
  return (
    <div
      className="border border-[rgba(0,240,255,0.15)] bg-[#0A1428] p-7 hover:border-[rgba(0,240,255,0.4)] hover:shadow-[0_0_24px_rgba(0,240,255,0.12)] transition-all"
      data-testid={testId}
    >
      <div className="w-10 h-10 inline-flex items-center justify-center border border-[rgba(0,240,255,0.3)] text-[#00F0FF]">
        {icon}
      </div>
      <h3 className="font-display mt-5 text-xl text-white font-semibold">
        {title}
      </h3>
      <p className="mt-3 text-slate-300 text-sm sm:text-base leading-[1.75]">{body}</p>
    </div>
  );
}

export function SectionTag({ children }) {
  return (
    <span className="inline-flex items-center gap-3 font-mono-tech text-[11px] uppercase tracking-[0.32em] text-[#00F0FF]">
      <span className="w-6 h-px bg-[#00F0FF]" />
      {children}
    </span>
  );
}
